import React, { useContext, useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { useLoader } from "../../../utils/common";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);

  const [product, setProduct] = useState([]);
  const [stock, setStock] = useState([]);
  const [supplier, setSupplier] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const Select4Data = async (data, name) => {
    return (
      data?.map((item) => ({
        value: item?.id,
        label: item?.name,
        name: name,
        category_id: item?.p_category_id,
      })) || []
    );
  };

  const GetAllProduct = async () => {
    const response = await getData(`/common/masters/stock-available-product`);
    if (response?.success) {
      setProduct(await Select4Data(response.data, "product_id"));
    }
  };

  const Select3Data = async (data, name) => {
    return (
      data?.map((item) => ({
        value: item?.id,
        label: `${item?.barcode_no}-${item?.model}`,
        name: name,
        supplier_id: item?.supplier_id,
      })) || []
    );
  };

  const GetAllStock = async (id) => {
    const response = await getData(
      `/common/masters/stock-available-sale/${id}`
    );
    if (response?.success) {
      const stockData = await Select3Data(response.data, "stock_id");
      setStock(stockData);
      return stockData;
    }
    return [];
  };

  const GetAllSupplier = async () => {
    const response = await getData("/common/masters/all-supplier");
    if (response?.success) {
      setSupplier(await Select2Data(response?.data, "supplier_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
    GetAllSupplier();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      quantitys: [{}], // Initialize with 1 row by default
    },
  });

  const { loading, withLoader } = useLoader();

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      const variants = [];
      data.quantitys.forEach((val) => {
        variants.push({
          product_id: val?.product_id?.value,
          supplier_id: val?.supplier_id?.value,
          stock_id: val?.stock_id?.value,
          description: val.description,
        });
      });

      DataToSend.append("quantitys", JSON.stringify(variants));

      const response = await withLoader(() =>
        postData(`/admin/purchase-order/supplier-return`, DataToSend)
      );

      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "quantitys",
  });

  // 1. Reset form to exactly 1 blank row whenever modal visibility changes
  useEffect(() => {
    if (props.show) {
      reset({
        quantitys: [{}],
      });
    }
  }, [props.show, reset]);

  // 2. Auto-select product, stock, and supplier ONLY when opened from Edit Product
  useEffect(() => {
    if (!props.show || !props.isFromProductEdit || !props.productId) return;

    const handleAutoSelect = async () => {
      if (product.length > 0) {
        const selectedProd = product.find(
          (p) => String(p.value) === String(props.productId)
        );

        if (selectedProd) {
          setValue("quantitys.0.product_id", selectedProd);

          const stockOptions = await GetAllStock(selectedProd.value);

          if (stockOptions.length > 0) {
            const targetStock = props.stockId
              ? stockOptions.find(
                (s) => String(s.value) === String(props.stockId)
              ) || stockOptions[0]
              : stockOptions[0];

            setValue("quantitys.0.stock_id", targetStock);

            if (targetStock?.supplier_id && supplier.length > 0) {
              const matchedSupplier = supplier.find(
                (s) => String(s.value) === String(targetStock.supplier_id)
              );
              if (matchedSupplier) {
                setValue("quantitys.0.supplier_id", matchedSupplier);
              }
            }
          }
        }
      }

      if (props.supplierId && supplier.length > 0) {
        const matchedSupplier = supplier.find(
          (s) => String(s.value) === String(props.supplierId)
        );
        if (matchedSupplier) {
          setValue("quantitys.0.supplier_id", matchedSupplier);
        }
      }
    };

    handleAutoSelect();
  }, [
    props.show,
    props.isFromProductEdit,
    props.productId,
    props.supplierId,
    props.stockId,
    product,
    supplier,
  ]);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Supplier Return
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row>
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder mt-3">
                  <h6> Product Return</h6>
                </div>

                {fields.map((variant, index) => (
                  <div className="package-details-section" key={variant.id}>
                    <div className="main-form-section">
                      <Row>
                        {/* Product Dropdown */}
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Product</Form.Label>
                              <Form.Group>
                                <Controller
                                  name={`quantitys.${index}.product_id`}
                                  control={control}
                                  rules={{ required: "Select Product" }}
                                  render={({ field }) => (
                                    <Select
                                      {...field}
                                      placeholder="Select Product"
                                      isDisabled={props.isFromProductEdit}
                                      options={product}
                                      onChange={(selectedOption) => {
                                        field.onChange(selectedOption);
                                        setValue(
                                          `quantitys.${index}.stock_id`,
                                          null
                                        );
                                        setValue(
                                          `quantitys.${index}.supplier_id`,
                                          null
                                        );
                                        if (selectedOption?.value) {
                                          GetAllStock(selectedOption.value);
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors?.quantitys?.[index]?.product_id && (
                                  <span className="text-danger">
                                    {
                                      errors.quantitys[index].product_id
                                        .message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>

                        {/* Stock Dropdown */}
                        {[2, 5].includes(
                          Number(watch(`quantitys.${index}.product_id`)?.category_id)
                        ) && (
                            <Col md={4}>
                              <div className="main-form-section mt-3">
                                <Row className="justify-content-center">
                                  <Form.Label>Stock</Form.Label>
                                  <Form.Group>
                                    <Controller
                                      name={`quantitys.${index}.stock_id`}
                                      control={control}
                                      rules={{ required: "Select Stock" }}
                                      render={({ field }) => (
                                        <Select
                                          {...field}
                                          isDisabled={props.isFromProductEdit} // <-- Added isDisabled prop
                                          options={stock}
                                          onChange={(selectedOption) => {
                                            field.onChange(selectedOption);
                                            if (selectedOption?.supplier_id) {
                                              const selectedSupplier = supplier.find(
                                                (s) =>
                                                  String(s.value) === String(selectedOption.supplier_id)
                                              );
                                              setValue(
                                                `quantitys.${index}.supplier_id`,
                                                selectedSupplier || null
                                              );
                                            }
                                          }}
                                        />
                                      )}
                                    />
                                    {errors?.quantitys?.[index]?.stock_id && (
                                      <span className="text-danger">
                                        {errors.quantitys[index].stock_id.message}
                                      </span>
                                    )}
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          )}

                        {/* Supplier Dropdown */}
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Supplier</Form.Label>
                              <Form.Group>
                                <Controller
                                  name={`quantitys.${index}.supplier_id`}
                                  control={control}
                                  rules={{ required: "Select Supplier" }}
                                  render={({ field }) => (
                                    <Select
                                      {...field}
                                      isDisabled={props.isFromProductEdit} // <-- Added isDisabled prop
                                      options={supplier}
                                    />
                                  )}
                                />
                                {errors?.quantitys?.[index]?.supplier_id && (
                                  <span className="text-danger">
                                    {errors.quantitys[index].supplier_id.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>

                        {/* Description */}
                        <Col md={12}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Description</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  placeholder="Description"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.quantitys?.[index]?.description,
                                  })}
                                  {...register(
                                    `quantitys.${index}.description`,
                                    {
                                      required: "Description is required",
                                      validate: (value) =>
                                        value.length <= 200 ||
                                        "Data must be 200 characters or less",
                                    }
                                  )}
                                />
                                {errors?.quantitys?.[index]?.description && (
                                  <span className="text-danger">
                                    {
                                      errors.quantitys[index].description
                                        .message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                      </Row>

                      {/* Remove Button - Hidden when opened from Edit Product */}
                      {fields.length > 1 && !props.isFromProductEdit && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => remove(index)}
                        >
                          Remove Product
                        </button>
                      )}
                      <hr />
                    </div>
                  </div>
                ))}

                {/* Add Product Button - Hidden when opened from Edit Product */}
                {!props.isFromProductEdit && (
                  <div className="text-center">
                    <button
                      type="button"
                      className="add-varient"
                      onClick={() => append({})}
                    >
                      + Add Product
                    </button>
                  </div>
                )}
              </div>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link to="#">
                    <CancelButton
                      name={"Cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>
                  <SaveButton
                    name={"Save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;